function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useContext, useMemo } from "react";
import ThemeContext from "../ThemeProvider/ThemeContext";
import getStyle from "./Badge.style";
var validMeatBalls = [
    'tertiary',
    'danger'
];
var Badge = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? 'tertiary' : _variant, content = _param.content, propDrop = _objectWithoutProperties(_param, [
        "variant",
        "content"
    ]);
    var style = useStyle({
        variant: validMeatBalls.includes(variant.toLowerCase()) ? variant.toLowerCase() : 'tertiary',
        content: content
    });
    return _jsx("span", _objectSpread({}, propDrop, {
        css: style,
        children: content
    }));
};
export { Badge };
function useStyle(param) {
    var variant = param.variant, content = param.content;
    var theme = useContext(ThemeContext);
    var style = useMemo(function() {
        return getStyle({
            theme: theme
        });
    }, [
        theme
    ]);
    var variantColor = variant === 'danger' ? style.danger : style.tertiary;
    return typeof content === 'undefined' ? _objectSpread({}, style.indicator.base, variantColor) : _objectSpread({}, style.badge.base, variantColor);
}
